module.exports = __webpack_public_path__ + "static/media/Material.3576ea4a.webp";